export default __webpack_public_path__ + "static/CBX-Mapa-Parking-MAY2023-solo-nombres-ESP-8ddf58ccb41c30e5563d94dc2c3aafb2.png";